import { Helmet } from "react-helmet-async";

const siteUrl = "https://www.sevaafoundation.com";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "NGO",
  "@id": `${siteUrl}/#ngo`,
  name: "SEVAA Foundation",
  alternateName: "Swadesh Sevaa Charitable Foundation",
  url: siteUrl,
  logo: {
    "@type": "ImageObject",
    url: `${siteUrl}/logo512.png`,
    width: 512,
    height: 512,
  },
  image: `${siteUrl}/og-blogs.jpg`,
  email: "info@sevaafoundation.com",
  telephone: "+91-9910218596",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Noida",
    addressRegion: "Uttar Pradesh",
    addressCountry: "IN",
  },
  areaServed: {
    "@type": "Country",
    name: "India",
  },
  knowsAbout: [
    "Child Education",
    "Healthcare Support",
    "Hunger Relief",
    "Women Empowerment",
    "Tree Plantation",
    "Elderly Care",
    "Medical and Blood Donation",
    "CSR Partnerships",
    "NGO Volunteering",
  ],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  name: "SEVAA Foundation",
  alternateName: "Swadesh Sevaa Charitable Foundation",
  url: siteUrl,
  publisher: {
    "@id": `${siteUrl}/#ngo`,
  },
  inLanguage: "en-IN",
};

const SitewideSEO = () => (
  <Helmet>
    <meta name="referrer" content="strict-origin-when-cross-origin" />
    <meta name="format-detection" content="telephone=yes" />
    <script type="application/ld+json">
      {JSON.stringify(organizationSchema)}
    </script>
    <script type="application/ld+json">
      {JSON.stringify(websiteSchema)}
    </script>
  </Helmet>
);

export default SitewideSEO;
